import { render, staticRenderFns } from "./work-test-detail.vue?vue&type=template&id=4da744cc&scoped=true"
import script from "./work-test-detail.vue?vue&type=script&lang=js"
export * from "./work-test-detail.vue?vue&type=script&lang=js"
import style0 from "./work-test-detail.vue?vue&type=style&index=0&id=4da744cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da744cc",
  null
  
)

export default component.exports